module.exports = __webpack_public_path__ + "static/media/mastercard.15c0c9f6.svg";